import { AutomationsPresentationV1 } from 'Automations/automationEditor'

export const QUOTE_APPROVAL_BASE: AutomationsPresentationV1 = {
  version: 1,
  nodes: [
    {
      id: '186eae8b-de70-44a7-982b-eed64179d244',
      type: 'START_QUOTE_REQUIRES_APPROVAL',
      position: { x: -274, y: -2 },
      data: { name: '', trigger: 'QUOTE_REQUIRES_APPROVAL' }
    },
    {
      id: '5eb53a0d-6f13-424c-ab5a-0601c34e1530',
      type: 'REVIEW_QUOTE',
      position: { x: -48, y: -40 },
      data: { name: '', reviewType: 'QUOTE', approverUserIds: [] }
    },
    {
      id: '08878c62-a1d8-4423-9d6e-60c347bb4271',
      type: 'ACTION_PUBLISH_QUOTE',
      position: { x: 177, y: -49 },
      data: { name: '', actionType: 'PUBLISH_QUOTE' }
    },
    {
      id: '1bf11ede-3887-40b0-b668-820465fd7987',
      type: 'END',
      position: { x: 395, y: -50 },
      data: { name: '' }
    },
    {
      id: 'f8c929b4-7edc-43d9-80d0-12b42adef0d3',
      type: 'END',
      position: { x: 180, y: 97 },
      data: { name: '' }
    }
  ],
  edges: [
    {
      source: '186eae8b-de70-44a7-982b-eed64179d244',
      sourceHandle: '186eae8b-de70-44a7-982b-eed64179d244:source',
      target: '5eb53a0d-6f13-424c-ab5a-0601c34e1530',
      targetHandle: '5eb53a0d-6f13-424c-ab5a-0601c34e1530:target',
      id: 'xy-edge__186eae8b-de70-44a7-982b-eed64179d244186eae8b-de70-44a7-982b-eed64179d244:source-5eb53a0d-6f13-424c-ab5a-0601c34e15305eb53a0d-6f13-424c-ab5a-0601c34e1530:target'
    },
    {
      source: '5eb53a0d-6f13-424c-ab5a-0601c34e1530',
      sourceHandle: '5eb53a0d-6f13-424c-ab5a-0601c34e1530:source:APPROVED',
      target: '08878c62-a1d8-4423-9d6e-60c347bb4271',
      targetHandle: '08878c62-a1d8-4423-9d6e-60c347bb4271:target',
      id: 'xy-edge__5eb53a0d-6f13-424c-ab5a-0601c34e15305eb53a0d-6f13-424c-ab5a-0601c34e1530:source:APPROVED-08878c62-a1d8-4423-9d6e-60c347bb427108878c62-a1d8-4423-9d6e-60c347bb4271:target'
    },
    {
      source: '08878c62-a1d8-4423-9d6e-60c347bb4271',
      sourceHandle: '08878c62-a1d8-4423-9d6e-60c347bb4271:source',
      target: '1bf11ede-3887-40b0-b668-820465fd7987',
      targetHandle: '1bf11ede-3887-40b0-b668-820465fd7987:target',
      id: 'xy-edge__08878c62-a1d8-4423-9d6e-60c347bb427108878c62-a1d8-4423-9d6e-60c347bb4271:source-1bf11ede-3887-40b0-b668-820465fd79871bf11ede-3887-40b0-b668-820465fd7987:target'
    },
    {
      source: '5eb53a0d-6f13-424c-ab5a-0601c34e1530',
      sourceHandle: '5eb53a0d-6f13-424c-ab5a-0601c34e1530:source:REJECTED',
      target: 'f8c929b4-7edc-43d9-80d0-12b42adef0d3',
      targetHandle: 'f8c929b4-7edc-43d9-80d0-12b42adef0d3:target',
      id: 'xy-edge__5eb53a0d-6f13-424c-ab5a-0601c34e15305eb53a0d-6f13-424c-ab5a-0601c34e1530:source:REJECTED-f8c929b4-7edc-43d9-80d0-12b42adef0d3f8c929b4-7edc-43d9-80d0-12b42adef0d3:target'
    }
  ]
}
